<template>
    <div class="cbs-container">
        <cloud-layout
            @onClickSubmit="onAsk"
            name="工商注册服务"
            type="CRS"
        >
            <product-nav slot="nav" current-label="本地工商注册"></product-nav>
            <product-buy
                slot="buy"
                :base-info="baseInfo"
                type="cbs"
                :adding="adding"
                @buy="onBuy"
                @ask="onAsk"
                @shopping="addShoppingCart"
            >
                <div
                    slot="form"
                    class="form-data-container"
                >
                    <div class="form-item" v-if="formData.comName">
                        <div class="form-label">抢注名称：</div>
                        <div class="form-content preempt-company-name">{{ formData.comName }}</div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">服务地区：</div>
                        <div class="form-content">
                            <el-select
                                v-model="formData.regionCode"
                                :filterable="true"
                                size="small"
                                @change="onRegionChange"
                            >
                                <el-option-group
                                    v-for="group in regionDatasource"
                                    :key="group.label"
                                    :label="group.label"
                                >
                                    <el-option
                                        v-for="item in group.options"
                                        class="cbs-city-select-option"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    >
                                        <span>{{ item.label }}</span>
                                        <span v-if="item.isSpecialCity" class="hui-icon"></span>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">公司性质：</div>
                        <div class="form-content">
                            <div
                                v-for="item in companyDataSource"
                                :key="item.value"
                                :class="['select-item',item.value === formData.companyType ? 'be-selected' : '']"
                                @click="onSelect('companyType', item.value)"
                            >
                                <div>{{ item.label }}</div>
                                <img
                                    v-if="item.value === formData.companyType"
                                    class="selected-img"
                                    src="../assets/selected.png"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">纳税人类型：</div>
                        <div class="form-content">
                            <div
                                v-for="item in taxpayerTypeDataSource"
                                :key="item.value"
                                :class="['select-item',item.value === formData.taxpayerType ? 'be-selected' : '']"
                                @click="onSelect('taxpayerType', item.value)"
                            >
                                <div>{{ item.label }}</div>
                                <img
                                    v-if="item.value === formData.taxpayerType"
                                    class="selected-img"
                                    src="../assets/selected.png"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">服务类型：</div>
                        <div class="form-content">
                            <div
                                v-for="item in serviceTypeDataSource"
                                :key="item.value"
                                :class="['select-item',item.value === formData.serviceType ? 'be-selected' : '']"
                                @click="onSelect('serviceType', item.value)"
                            >
                                <div>{{ item.label }}</div>
                                <img
                                    v-if="item.value === formData.serviceType"
                                    class="selected-img"
                                    src="../assets/selected.png"
                                />
                            </div>
                        </div>
                    </div>

                    <div class="form-item">
                        <div class="form-label">服务内容：</div>
                        <div class="form-content">
                            <div
                                v-for="item in serviceContentDataSource"
                                :key="item.value"
                                class="service-content-item"
                            >
                                <div>{{ item }}</div>
                            </div>
                        </div>
                    </div>

                    <div class="form-item crs-comment" v-if="showComment">
                        <div class="form-label">备注：</div>
                        <div class="form-content">须自备商业注册地址</div>
                    </div>
                </div>
            </product-buy>
            <product-intro slot="intro" type="CRS">
                <div
                    slot="content"
                    class="product-info-content"
                >
                    <div class="info-item">
                        <h2>{{ productInfo.title }}</h2>
                        <p class="intro-des">{{ productInfo.infoDesc }}</p>
                        <div class="info-card-wrap">
                            <div
                                class="info-card"
                                v-for="(info, key) in productInfo.infoList"
                                :key="key"
                            >
                                <div class="info-card-title info-border">{{ info.title }}</div>
                                <div class="info-card-content">{{ info.content }}</div>
                                <div class="info-card-tag">
                                    <span v-for="(tag, tagKey) in info.tag" :key="tagKey">
                                        {{ tag }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-item">
                        <h2>{{ advantage.title }}</h2>
                        <div class="advantage-info-wrap">
                            <div
                                class="advantage-info"
                                v-for="(item, key) in advantage.infoList"
                                :key="key"
                            >
                                <div :class="`advantage_info_img advantage_bg${key}`"></div>
                                <div class="advantage-info-content">
                                    <div class="info-card-title advantage-card-title">
                                        {{ item.title }}
                                    </div>
                                    <ul>
                                        <li
                                            v-for="(info, infoKey) in item.info"
                                            :key="infoKey"
                                        >{{ info }}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="info-item">
                        <h2>{{ process.title }}</h2>
                        <p class="intro-des">{{ process.infoDesc }}</p>
                        <div class="process-img"></div>
                    </div>
                    <div class="info-item">
                        <h2>{{ material.title }}</h2>
                        <div class="material-info-wrap">
                            <div class="material-info-left">
                                <div
                                    class="material-info"
                                    v-for="(info, key) in material.infoList"
                                    :key="key"
                                >
                                    <div class="material-info-icon"></div>
                                    <div>
                                        <p class="info-strip-title">{{ info.title }}</p>
                                        <p class="info-strip-desc">{{ info.content }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="material-info-right"></div>
                        </div>
                    </div>
                    <div class="info-item">
                        <h2>{{ question.title }}</h2>
                        <div class="question-info-wrap">
                            <div
                                class="question-info"
                                v-for="(info, key) in question.infoList"
                                :key="key"
                            >
                                <div :class="`question-info-num question-index`">Q{{ key + 1 }}</div>
                                <div class="question-info-content">
                                    <p class="info-strip-title">{{ info.title }}</p>
                                    <p class="info-strip-desc">{{ info.content }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </product-intro>
        </cloud-layout>

        <submit-dialog
            v-if="showSubmitDialog"
            type="CRS"
            :title="getLabelByValue(serviceTypeDataSource, formData.serviceType)"
            :biz-type="bizTypeSource[formData.serviceType]"
            :area="formData.regionCode"
            @close="onClose"
        ></submit-dialog>

        <verify-user-phone
            v-if="openPhoneDialog"
            :protocol="protocol"
            :saved-phone="userPhone"
            @saveUserPhone="saveUserPhone"
            @onClose="onClosePhoneDialog"
            @onSubmit="skipToOrderPage"
        ></verify-user-phone>
    </div>
</template>

<script>
import {Message} from 'element-ui';
import CloudLayout from '../components/CloudLayout.vue';
import ProductBuy from '../components/NewProductBuy.vue';
import ProductIntro from '../components/ProductIntro.vue';
import VerifyUserPhone from '../components/VerifyUserPhone.vue';
import ProductNav from '../components/ProductNav.vue';

import {store} from '../util/store';
import client from '../common/client';
import {isLogin, isOnline, skipToLoginPage} from '../util/helper';
import SubmitDialog from '../components/NewSubmitDialog.vue';
import * as cbsDataSource from './data/cbs';
import {regionMixin, crsDetailMixin} from '../components/mobile/mixin';
import {CrsComType, CrsTaxpayerType, packageInfo} from '../pages/data/order';

const {metaInfo, baseInfo, productInfo, advantage, process,
    material, question, companyDataSource, taxpayerTypeDataSource,
    serviceTypeDataSource, bizTypeSource, serviceContentDataSource,
    packageTypeDataSource, infoDesc
} = cbsDataSource;

export default {
    mixins: [regionMixin, crsDetailMixin],

    components: {
        CloudLayout,
        ProductNav,
        ProductBuy,
        ProductIntro,
        SubmitDialog,
        VerifyUserPhone
    },
    metaInfo,
    data() {
        return {
            showSubmitDialog: false,
            infoDesc,
            baseInfo,
            productInfo,
            advantage,
            process,
            material,
            question,
            companyDataSource,
            taxpayerTypeDataSource,
            serviceTypeDataSource,
            bizTypeSource,
            formData: {
                serviceType: 'COMPANY_REGISTRATION',
                regionCode: 110100,
                taxpayerType: '小规模纳税人',
                companyType: '有限公司'
            },
            consultCities: [],
            codeToPinyin: {},
            codeToName: {},
            openPhoneDialog: false,
            userPhone: '',
            protocol: {
                href: 'https://cloud.baidu.com/doc/CBS/s/skj9vos8w',
                text: '《百度智能云工商注册服务协议》'
            },
            hasLogin: false,
            adding: false
        };
    },
    computed: {
        serviceContent() {
            const serviceType = this.formData.serviceType;
            const serviceTypeDataSource = this.serviceTypeDataSource;
            for (let i = 0; i < serviceTypeDataSource.length; i++) {
                if (serviceTypeDataSource[i].value === serviceType) {
                    return serviceTypeDataSource[i].serviceContent;
                }
            }
            return [];
        },
        serviceContentDataSource() {
            const serviceType = this.formData.serviceType;
            return serviceContentDataSource[serviceType] || [];
        },
        showComment() {
            const serviceType = this.formData.serviceType;
            return serviceType === 'COMPANY_REGISTRATION' || serviceType === 'SUPER_VALUE';
        }
    },

    async created() {
        await this.getRegion();
        const {
            consultCities,
            pkgCityGroups,
            comRegDisableArea,
            comRegPreferentialCities,
            nameToCode,
            nameToPinyin
        } = this.staticRegionData;
        let codeToPinyin = {};
        Object.keys(nameToPinyin).forEach(key => {
            codeToPinyin[nameToCode[key]] = nameToPinyin[key];
        });
        let codeToName = {};
        Object.keys(nameToCode).forEach(key => {
            codeToName[nameToCode[key]] = key;
        });
        this.codeToPinyin = codeToPinyin;
        this.codeToName = codeToName;
        this.companyRegionDatasource = this.convertRegionDataToGroupData(consultCities, comRegPreferentialCities);
        this.packageRegionDatasource = this.convertRegionDataToGroupData(pkgCityGroups, comRegPreferentialCities);
        this.comRegDisableArea = comRegDisableArea;
        this.setRegionDatasource();
        this.getUrlParam();
        this.onRegionChange();
    },

    mounted() {
        isLogin().then(res => {
            this.hasLogin = res && res.result && res.result.hasLogin;
        });
    },
    methods: {
        onClose() {
            this.showSubmitDialog = false;
        },

        // 关闭留咨弹窗
        onClosePhoneDialog() {
            this.openPhoneDialog = false;
        },

        // 打开留咨弹窗
        onOpenPhoneDialog() {
            this.openPhoneDialog = true;
        },

        // 保存用户电话号码
        saveUserPhone(userPhone) {
            this.userPhone = userPhone;
        },

        getFlavorParkRegionPinyinParam(region) {
            let codeToPinyin = this.codeToPinyin;
            // 地区拼音加上后缀
            return `${codeToPinyin[region]}`;
        },

        getFlavorComTypeAndTaxpayerType(comType, taxpayerType) {
            return `${CrsComType[comType]}-${CrsTaxpayerType[taxpayerType]}`;
        },

        getFlavorValue(comType, taxpayerType, packageType) {
            if (comType === '集团公司' && !packageType) {
                return comType;
            }
            return `${comType}-${taxpayerType}`;
        },

        getCrsCouponFlavorList(productType, area, comType, taxpayerType) {
            return [
                {
                    name: 'productType',
                    value: productType,
                    scale: 1
                },
                {
                    name: 'area',
                    value: area,
                    scale: 1
                },
                {
                    name: 'comType',
                    value: comType,
                    scale: 1
                },
                {
                    name: 'taxpayerType',
                    value: taxpayerType,
                    scale: 1
                }
            ];
        },

        // 加入购物车
        addShoppingCart() {
            if (!this.hasLogin) {
                skipToLoginPage();
            }
            if (this.adding) {
                return;
            }
            const {
                regionCode,
                serviceType,
                companyType
            } = this.formData;
            let area = regionCode;
            let taxpayerType = this.getRealValueByLabel(taxpayerTypeDataSource, this.formData.taxpayerType);
            let comType = this.getRealValueByLabel(companyDataSource, companyType);
            let packageType = packageTypeDataSource[serviceType];

            const flavorValue = this.getFlavorValue(
                CrsComType[comType],
                CrsTaxpayerType[taxpayerType],
                packageType
            );

            if (!packageType) {
                packageType = 0;
            }
            packageType = packageType.toString();

            const crsCouponFlavorList = this.getCrsCouponFlavorList(
                packageInfo[packageType].productTypeValue,
                area,
                CrsComType[comType],
                CrsTaxpayerType[taxpayerType],
            );

            let cartData = {
                serviceType: 'CBS',
                serviceName: '公司注册',
                displayName: '公司注册',
                productType: 'prepay',
                count: 1,
                extra: JSON.stringify({
                    bizType: packageInfo[packageType].bizType,
                    detail: {
                        bizType: packageInfo[packageType].bizType,
                        area,
                        taxpayerType: CrsTaxpayerType[taxpayerType],
                        comType: CrsComType[comType],
                        packageType: packageType === '0' ? '' : packageType
                    }
                }),
                discountFlag: true,
                uniqueQuantity: true,
                nonModifyQuantity: true,
                pricingDetail: {
                    policy: ''
                },
                campaignId: '',
                config: {
                    serviceType: 'CBS',
                    serviceName: '代理记账',
                    count: 1,
                    duration: 1,
                    orderType: 'NEW',
                    productType: 'prepay',
                    subProductType: 'Project',
                    region: 'global',
                    timeUnit: 'DAY',
                    unitText: '次',
                    flavor: [
                        {
                            name: packageType !== '' ?
                                `${this.codeToPinyin[area]}_pkg${packageType}` :
                                `${this.codeToPinyin[area]}`,
                            value: flavorValue,
                            scale: 1
                        },
                        {
                            name: 'subServiceType',
                            value: packageInfo[packageType].subServiceTypeValue,
                            scale: 1
                        },
                        ...crsCouponFlavorList
                    ]
                },
                displayConfig: [
                    {
                        key: '服务地区',
                        value: this.codeToName[area]
                    },
                    {
                        key: '公司性质',
                        value: CrsComType[comType]
                    },
                    {
                        key: '纳税人类型',
                        value: CrsTaxpayerType[taxpayerType]
                    },
                    {
                        key: '服务类型',
                        value: packageInfo[packageType].serviceName
                    }
                ]
            };
            this.adding = true;
            client.addShoppingCart(cartData).then((res) => {
                if (res && res.data && res.data.success) {
                    // window.shoppingCart.showSuccessTip();
                    window.shoppingCart.setup();
                    Message({
                        type: 'success',
                        message: '加入购物车成功',
                        offset: 60
                    });
                    this.adding = false;
                } else {
                    Message({
                        type: 'error',
                        message: '加入购物车失败',
                        offset: 60
                    });
                    this.adding = false;
                }
            });
        },

        setRegionDatasource() {
            const {serviceType, regionCode} = this.formData;
            this.regionDatasource = serviceType === 'COMPANY_REGISTRATION'
                ? this.companyRegionDatasource
                : this.packageRegionDatasource;

            this.isInRegionDatasource(this.regionDatasource, regionCode);

            if (!this.isInRegionDatasource(this.regionDatasource, regionCode)) {
                const data = this.regionDatasource[0].options[0] || {};
                this.formData.regionCode = data.value || '';
            }

            this.setCompanyDataSource();
            store.setRegionDatasource(this.regionDatasource);
            if (window.location.href.indexOf('from=require') > -1) {
                this.showSubmitDialog = true;
                const href = window.location.href.replace('from=require', '');
                window.history.pushState({}, '', href);
            }
        },

        onBuy() {
            if (!this.hasLogin) {
                skipToLoginPage();
            }
            else {
                this.onOpenPhoneDialog();
            }
        },

        skipToOrderPage(phone) {
            const {regionCode, serviceType, taxpayerType, companyType, comName} = this.formData;
            const taxpayerTypeValue = this.getRealValueByLabel(taxpayerTypeDataSource, taxpayerType);
            const companyTypeValue = this.getRealValueByLabel(companyDataSource, companyType);
            const targetOrigin = isOnline
                ? 'https://console.bce.baidu.com'
                : 'https://qasandbox.bcetest.baidu.com';
            // eslint-disable-next-line
            let targetUrl = `${targetOrigin}/cbs/#/crs/order/submit?area=${regionCode}&taxpayerType=${taxpayerTypeValue}`
                + `&comType=${companyTypeValue}&packageType=${packageTypeDataSource[serviceType]}`;
            if (phone) {
                targetUrl += '&phone=' + phone;
            }
            if (comName) {
                targetUrl += '&comName=' + comName;
            }
            window.open(targetUrl, '_blank');
        },

        onAsk() {
            this.showSubmitDialog = true;
        },

        getLabelByValue(datasource, value) {
            for (let i = 0; i < datasource.length; i++) {
                if (datasource[i].value === value) {
                    return datasource[i].label;
                }
            }
            return '';
        },

        getRealValueByLabel(datasource, value) {
            for (let i = 0; i < datasource.length; i++) {
                if (datasource[i].value === value) {
                    return datasource[i]._value;
                }
            }
            return '';
        }
    }
};
</script>

<style lang="less">
.cbs-container {
    .product-buy-container {
        height: auto;
    }
    .crs-comment {
        margin-top: -16px;
        padding-bottom: 16px;
        .form-content {
            font-size: 14px;
            line-height: 30px;
            color: #191c3d;
            opacity: 0.7;
        }
    }
    .preempt-company-name {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #2469F3;
        font-weight: 400;
        line-height: 30px;
    }
    .price-content {
        margin-bottom: 30px;
    }
    .form-content {
        width: 460px;
        .select-item:nth-child(1) {
            margin-bottom: 16px;
        }
    }
    .service-content-item {
        color: #2468f2;
        margin-bottom: 16px;
        display: inline-block;
        margin-right: 30px;
        line-height: 30px;
        font-size: 14px;
        font-family: PingFang SC;
    }
    .product-info-container .product-info-content > div:nth-child(odd) {
        background-color: #fff;
    }
    .product-info-container .product-info-content > div:nth-child(3) {
        background-color: #F7FAFF;
    }
    .product-info-content {
        padding-bottom: 20px;
        .info-item {
            overflow: auto;
            padding: 0 55px;
            h2 {
                font-family: PingFangSC-Medium;
                font-size: 28px;
                color: #1B1E3F;
                letter-spacing: 1px;
                text-align: center;
                font-weight: 500;
                margin: 40px 0 10px 0;
            }
            .intro-des {
                opacity: 0.6;
                font-family: PingFangSC-Regular;
                font-size: 16px;
                color: #1B1E3F;
                letter-spacing: 0;
                text-align: center;
                font-weight: 400;
                margin-bottom: 30px;
            }
        }


        .info-card-wrap {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
        }

        .info-card {
            width: 260px;
            height: 224px;
            border: 1px solid #2A62FE;
            border-radius: 5px;
            box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.1);
            padding: 18px 20px 22px 20px;
            box-sizing: border-box;
            margin-bottom: 20px;
            background-color: #fff;
            .info-card-content {
                height: 80px;
                margin: 16px 0;
                opacity: 0.5;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #1B1E3F;
                letter-spacing: 0;
                font-weight: 400;
            }
            .info-card-tag {
                display: flex;
                flex-wrap: wrap;

                span {
                    display: inline-block;
                    font-family: PingFangSC-Medium;
                    font-size: 12px;
                    color: #2A62FE;
                    letter-spacing: 0;
                    text-align: center;
                    font-weight: 500;
                    background-image: linear-gradient(90deg,
                        rgba(56,96,244,0.06) 0%,
                        rgba(56,96,244,0.12) 100%
                    );
                    border-radius: 4px;
                    padding: 4px 7px;
                    margin-right: 10px;
                }
            }
            .info-border {
                padding-bottom: 16px;
                border-bottom: 1px solid #E1E6F0;
            }
        }

        .info-card-title {
            font-family: PingFangSC-Medium;
            font-size: 19px;
            color: #2A62FE;
            letter-spacing: 0;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .advantage-info-wrap {
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            .advantage-info {
                display: flex;
                align-items: center;
                width: 50%;
                margin-bottom: 40px;
            }
            .advantage_info_img {
                width: 126px;
                height: 138px;
                background-size: 100%;
            }
            .advantage_bg0 {
                background-image: url(../assets/cbs/advantage1.png);
            }
            .advantage_bg1 {
                background-image: url(../assets/cbs/advantage2.png);
            }
            .advantage_bg2 {
                background-image: url(../assets/cbs/advantage3.png);
            }
            .advantage_bg3 {
                background-image: url(../assets/cbs/advantage4.png);
            }
            .advantage-info-content {
                padding-left: 30px;
                li {
                    opacity: 0.5;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #1B1E3F;
                    letter-spacing: 0;
                    font-weight: 400;
                    margin-bottom: 20px;
                    position: relative;
                    padding-left: 10px;
                    &::after {
                        content: "";
                        width: 4px;
                        height: 4px;
                        background: #2A62FE;
                        color: #148AE0;
                        position: absolute;
                        top: 50%;
                        bottom: 0;
                        transform: translateY(-50%);
                        left: 0;
                    }
                }
            }
            .advantage-card-title {
                margin-bottom: 20px;
            }
        }

        .process-img {
            width: 820px;
            height: 370px;
            margin: 0 auto 40px auto;
            overflow: hidden;
            background-image: url(../assets/cbs/process.png);
            background-size: 100%;
        }

        .material-info-wrap {
            display: flex;
            justify-content: space-between;
            .material-info-left {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
            .material-info {
                display: flex;
            }
            .material-info-icon {
                width: 20px;
                height: 20px;
                background-image: url(../assets/cbs/material_icon.png);
                background-size: 100%;
                margin: 5px 20px 0 0;
            }
            .material-info-right {
                width: 450px;
                height: 352px;
                background-image: url(../assets/cbs/material.png);
                background-size: 100%;
            }
        }

        .info-strip-title {
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 500;
            margin-bottom: 10px;
        }
        .info-strip-desc {
            opacity: 0.5;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #1B1E3F;
            letter-spacing: 0;
            font-weight: 400;
        }

        .question-info {
            display: flex;
            .question-info-num {
                width: 44px;
                height: 38px;
                margin-right: 20px;
                background-size: 100%;
                background-image: url('https://cbs-public.cdn.bcebos.com/portal/20220809/tip.png');
            }
            .question-info-content {
                margin-bottom: 20px;
                width: 756px;
            }
            .question-index {
                color: #FFF;
                line-height: 30px;
                letter-spacing: 2px;
                text-align: center;
            }
        }
    }
}
.cbs-city-select-option {
    .hui-icon {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-left: 10px;
        background: url(../assets/city-icon-hui.png) no-repeat;
        background-size: contain;
        vertical-align: middle;
    }
}
</style>
